// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".persona-aviso__texto[data-v-a5277b98] {\n  line-height: 16px;\n}", "",{"version":3,"sources":["/opt/buildhome/repo/src/modules/aawz-intelligence-v2/components/persona-aviso/persona-aviso.vue"],"names":[],"mappings":"AAqCA;EACE,iBAAA;AApCF","file":"persona-aviso.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n// O passo de 11px vem de `design/_ia-texto.sass` (classe no template).\n.persona-aviso__texto\n  line-height: 16px\n"]}]);
// Exports
module.exports = exports;
